import { useState, useEffect } from 'react';
import { LocalizedLink as Link } from '../../../components/LocalizedLink';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    
    // Get current path parts
    const pathParts = location.pathname.split('/').filter(Boolean);
    
    // If the first part is a supported language, replace it
    if (pathParts.length > 0 && (pathParts[0] === 'en' || pathParts[0] === 'es')) {
      pathParts[0] = newLang;
    } else {
      // Otherwise prepend the new language
      pathParts.unshift(newLang);
    }
    
    const newPath = `/${pathParts.join('/')}${location.search}${location.hash}`;
    navigate(newPath);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/80 backdrop-blur-md py-3 shadow-sm' : 'bg-transparent py-6'
        }`}
      >
        <div className="max-w-7xl mx-auto px-2 md:px-10">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="/assets/images/common/logo-mood.svg"
                alt="Mood Digital Agency"
                className="h-8"
              />
            </Link>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-900`}></i>
            </button>

            <nav className="hidden md:flex items-center space-x-12">
              <Link
                to="/"
                className="font-display text-[10px] font-medium tracking-[0.4em] uppercase transition-colors text-gray-900 hover:text-gray-400"
              >
                {t('navbar.home', 'Inicio')}
              </Link>
              <Link
                to="/services"
                className="font-display text-[10px] font-medium tracking-[0.4em] uppercase transition-colors text-gray-900 hover:text-gray-400"
              >
                {t('navbar.services', 'Servicios')}
              </Link>
              <Link
                to="/contact"
                className="font-display text-[10px] font-medium tracking-[0.4em] uppercase transition-colors text-gray-900 hover:text-gray-400"
              >
                {t('navbar.contact', 'Contacto')}
              </Link>
              <button
                onClick={toggleLanguage}
                className="font-display text-[10px] font-bold tracking-[0.1em] uppercase transition-all duration-300 text-gray-900 hover:text-gray-500 border border-gray-900 hover:border-gray-500 w-8 h-8 flex items-center justify-center rounded-full focus:outline-none bg-transparent"
              >
                <span className="relative left-[1px]">{i18n.language === 'es' ? 'EN' : 'ES'}</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <nav className="md:hidden fixed inset-0 bg-white z-[60] flex flex-col items-center justify-center space-y-8">
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-close-line text-3xl text-gray-900"></i>
          </button>
          <Link
            to="/"
            className="text-3xl font-display font-bold text-gray-900 hover:text-gray-400 transition-colors uppercase italic"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {t('navbar.home', 'Inicio')}
          </Link>
          <Link
            to="/services"
            className="text-3xl font-display font-bold text-gray-900 hover:text-gray-400 transition-colors uppercase italic"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {t('navbar.services', 'Servicios')}
          </Link>
          <Link
            to="/contact"
            className="text-3xl font-display font-bold text-gray-900 hover:text-gray-400 transition-colors uppercase italic"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {t('navbar.contact', 'Contacto')}
          </Link>
          <button
            onClick={() => {
              toggleLanguage();
              setIsMobileMenuOpen(false);
            }}
            className="text-2xl font-display font-bold text-gray-900 hover:text-gray-400 transition-colors uppercase italic border-t border-gray-100 pt-4 w-32"
          >
            {i18n.language === 'es' ? 'ENGLISH' : 'ESPAÑOL'}
          </button>
        </nav>
      )}
    </>
  );
};

export default Navbar;
